import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { QRCodeSVG } from 'qrcode.react';

// MUI
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { useTheme, useMediaQuery, Grid, List, ListItem } from '@mui/material';

// Custom Components
import PublicPage from '@/ui/PublicPage/PublicPage';
import { AppStoreButton, PlayStoreButton, HuaweiButton } from '@/ui/AppStoreButtons';

const APP_STORE_URL = 'https://apps.apple.com/us/app/sigurne-staze/id6760895360';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=hr.prehnit.sigurne_staze';
const APP_GALLERY_URL = 'https://appgallery.huawei.com/app/C118377085';

function MobileAppPage() {
  const { t } = useTranslation();

  const theme = useTheme();
  const isMobile: boolean = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <PublicPage overrideBgImage>
      <Box width="100%">
        <Container maxWidth="xxl" style={{ padding: 0 }}>
          <Grid container p={isMobile ? 3 : 10}>
            <Grid size={{ xs: 12, md: 5, lg: 3 }}>
              <Typography
                color="primary"
                variant="h4"
                component="h1"
                sx={{
                  position: !isMobile ? 'fixed' : 'unset',
                }}
              >
                {t('public.headings.mobile_app')}
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, md: 7, lg: 5 }} container mt={isMobile ? 2 : 0} columnGap="50px">
              <Box textAlign="left" mt={isMobile ? 2 : 0}>
                <Typography variant="body1" maxWidth="700px">
                  <Trans
                    i18nKey="public.mobile_app_description_1"
                    components={{ 1: <Typography component="span" fontWeight={600} color="primary" /> }}
                  />
                </Typography>

                <Box mt={3}>
                  <Typography fontWeight={600} variant="body1" color="primary">
                    {t('public.headings.mobile_app_advantages')}
                  </Typography>
                  <List sx={{ listStyleType: 'disc', padding: 0 }}>
                    {[
                      t('public.mobile_app_advantage_1'),
                      t('public.mobile_app_advantage_2'),
                      t('public.mobile_app_advantage_3'),
                      t('public.mobile_app_advantage_4'),
                      t('public.mobile_app_advantage_5'),
                    ].map((x, i) => (
                      <ListItem
                        // eslint-disable-next-line react/no-array-index-key
                        key={`mobile-app-advantage-${i}`}
                        sx={{ display: 'list-item', padding: 0, color: 'primary.main', fontSize: '0.875rem' }}
                      >
                        <Typography color="black">{x}</Typography>
                      </ListItem>
                    ))}
                  </List>
                </Box>

                <Box mt={4} display="flex" flexWrap="wrap" gap={!isMobile ? 16 : 2}>
                  <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
                    {!isMobile && <QRCodeSVG value={APP_STORE_URL} size={96} fgColor={theme.palette.secondary.main} />}
                    <AppStoreButton href={APP_STORE_URL} />
                  </Box>
                  <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
                    {!isMobile && <QRCodeSVG value={PLAY_STORE_URL} size={96} fgColor={theme.palette.secondary.main} />}
                    <PlayStoreButton href={PLAY_STORE_URL} />
                  </Box>
                  <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
                    {!isMobile && <QRCodeSVG value={APP_GALLERY_URL} size={96} fgColor={theme.palette.secondary.main} />}
                    <HuaweiButton href={APP_GALLERY_URL} />
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </PublicPage>
  );
}

export default MobileAppPage;
